import { lazy } from 'react';
import MobileBanner from '../../screens/Login/components/MobileBanner/MobileBanner';

const ICPFormMFE = lazy(() => import('./ICPFormMFE'));

export const ICPFormWithMobileBanner = () => (
  <>
    <ICPFormMFE />
    <MobileBanner />
  </>
);
